<span class="badge badge-pill" [class]="'badge-' + highlightLevel">
  {{ highlighted }}
</span>
